import { useMemo } from 'react';
import { cn } from '@/shared/lib';
import { AddressView, BasketInputs } from '@/features';
import { InputErrorMessage } from '@/shared/components';
import { ServiceTypeEnum } from '@/app/store/api/restApi';
import { useAppSelector, useAppDispatch, openDeliveryAddressModal, selectIsMinimalistic } from '@/app/store';

export const BasketOrderPointPersonalInfo = ({ isOrderAnotherPerson = false }: { isOrderAnotherPerson?: boolean }) => {
  const dispatch = useAppDispatch();
  const { deliveryDisabled, orderPointDisabled } = useAppSelector((state) => state.application);

  const { orderPointDelivery } = useAppSelector((state) => state.order);
  const { orderPointDelivery: anotherOrderPointDelivery } = useAppSelector((state) => state.orderAnotherPerson);
  const { commentsEnabled } = useAppSelector((state) => state.initial.settings);
  const orderPointError = useAppSelector((state) => state.errors.orderPointError);
  const isMinimalistic = useAppSelector(selectIsMinimalistic);

  const orderPointAddress = useMemo(() => {
    if (isOrderAnotherPerson) return anotherOrderPointDelivery.orderPointAddress;
    return orderPointDelivery.orderPointAddress;
  }, [anotherOrderPointDelivery.orderPointAddress, isOrderAnotherPerson, orderPointDelivery.orderPointAddress]);

  return (
    <div className={cn('flex flex-col', isMinimalistic ? 'gap-2' : 'gap-3')}>
      <div>
        <AddressView
          error={!!orderPointError}
          onClick={() => dispatch(openDeliveryAddressModal(isOrderAnotherPerson))}
          deliveryType={ServiceTypeEnum.OrderPoint}
          onClickMap={() => dispatch(openDeliveryAddressModal(isOrderAnotherPerson))}
          value={orderPointAddress}
          onlyDelivery={!deliveryDisabled && orderPointDisabled}
          onlyOrderPoint={deliveryDisabled && !orderPointDisabled}
        />

        {orderPointError && <InputErrorMessage text={orderPointError} />}
      </div>

      <BasketInputs commentsEnabled={commentsEnabled} isOrderAnotherPerson={isOrderAnotherPerson} />
    </div>
  );
};
